/* global wp */
import HubConnector from './hub-connector'
// Styles.
import './hub-connector.scss'

const { render } = wp.element

const container = document.getElementById('wpmudev-hub-connector')

// Only if container found.
if (container !== null) {
	render(<HubConnector/>, container)
}